import UnitPlanDetails from "UnitPlanDetails";

export default store => ({
  path: "unit",
  childRoutes: [UnitPlanDetails(store)],
});
